export default __webpack_public_path__ + "static/media/project.8f0f0c5b.jpg";